/**
 * Robots.txt Page
 *
 * Serves robots.txt content from CMS settings.
 * This component renders the robots.txt content as plain text.
 */

import { useEffect, useState } from 'react';
import { generateRobotsTxt } from '@/lib/seoManager';

export const RobotsTxtPage = () => {
  const [content, setContent] = useState<string>('');

  useEffect(() => {
    generateRobotsTxt().then((txt) => {
      setContent(txt);
    });
  }, []);

  // This will be handled by a server route in production
  // For now, we'll return the content
  return (
    <pre style={{ whiteSpace: 'pre-wrap', fontFamily: 'monospace', padding: '20px' }}>
      {content}
    </pre>
  );
};

export default RobotsTxtPage;
